import { getURLDomain, getURLMainDomain } from "../common/utils"

export const RIMS_LOCAL_STG_CONSTANTS = {
    LOGIN_TOKEN: 'LOGIN_TOKEN',
    USER_INFO: 'USER_INFO',
    USER_ID: 'USER_ID',
    USER_NAME: 'USER_NAME',
    MENU_AUTH_LIST: 'MENU_AUTH_LIST',
    DATA_AUTH_LIST: 'DATA_AUTH_LIST',
    SESSION_TIME_OUT: 'SESSION_TIME_OUT',
    DISABLE_BACK_PREVIOUS: 'DISABLE_BACK_PREVIOUS',
    TENANT_ID: 'TENANT_ID',
    SELECT_CONFIG_MODEL: 'SELECT_CONFIG_MODEL'
}

export const RIMS_COOKIE_STG_CONSTANTS = {
    LOGIN_TOKEN: 'ACCESS_TOKEN',
    USER_INFO: 'USER_INFO',
    DOMAIN: 'DOMAIN',
    MENU_AUTH_LIST: 'MENU_AUTH_LIST',
    DATA_AUTH_LIST: 'DATA_AUTH_LIST',
    SESSION_TIME_OUT: 'SESSION_TIME_OUT',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    USER_NAME: 'USER_NAME',
    USER_TENANT_ID: 'USER_TENANT_ID',
    USER_ID: 'USER_ID',
    USER_EMAIL: 'USER_EMAIL',
    USER_PRIVILEGES: 'USER_PRIVILEGES',
    AC_TENANT_ID: 'AC_TENANT_ID'
}

export const RIMS_SESSION_STG_CONSTANTS = {
    MODULE_NAME: 'MODULE_NAME',
    PATH_NAME: 'PATH_NAME',
    CURRENT_TENANT_ID: 'CURRENT_TENANT_ID',
}

export const enum ROLE_TYPE_ENUM {
    SUPER_ADMIN = 'Super Administrator',
    PLATFORM_ADMIN = 'Platform Administrator',
    ADMIN_CENTER_ADMIN = 'Admin Center Administrator'
}

export const pathAuthMapping = new Map([
    ["/notification/templates", "view_notification_templates"],
    ["/notification/payloads", "freyr_admin"],
    ["/notification/tasks", "freyr_admin"]
])

export const pathAuthWhiteList = [
    "/notification/history",
    "/notification/records/:recordId",
    "/workflow-manager",
    "/knowledge-manager",
]

export const COOKIE_SETUP = {
    path: "/",
    domain: getURLDomain(),
}

export const MAIN_COOKIE_SETUP = {
    path: "/",
    domain: getURLMainDomain()
  }

export const LANGUAGEMAP: { [key: string]: any } = {
    mui: {
      en: "enUS",
      zh: "zhCN",
      jp: "jaJP",
    },
  };

export const enum SubscriptionEnum {
  ONBOARD = 0,
  ONBOARDINGING = 1,
  ONBOARDED = 2,
  FAILED = 3,
  OFFBOARDINGING = 20,
  OFFBOARDED = 21,
}